/** Route path for the post-unit-1 Job Search Kickoff interstitial. */
export const KICKOFF_INTERSTITIAL_PATH = "/job-search/kickoff-intro";

/**
 * Query param carrying the lesson path the student was heading to. "Not now,
 * keep studying" navigates here (with `replace`).
 */
export const KICKOFF_INTERSTITIAL_RETURN_PARAM = "next";

/**
 * Zero-based index of the unit whose completion opens the interstitial. The
 * CDL curriculum's first unit is the trailer plus four practice-first
 * sections, so this fires on the advance past the 5th lesson.
 */
export const KICKOFF_INTERSTITIAL_UNIT_INDEX = 0;

/**
 * localStorage key prefix for the per-student "already shown" mark. Suffixed
 * with `:{uid}` so two students on one device never share it.
 */
export const KICKOFF_INTERSTITIAL_SEEN_KEY_PREFIX =
  "emerge.kickoffInterstitial.seen";

/**
 * Delay before the "Job matching starts today." lane fades in, so the road
 * has settled and the lane reads as arriving on top of it. Matches the Paper
 * board ("400ms, lane faded in").
 */
export const KICKOFF_LANE_FADE_DELAY_MS = 400;
